import ApiHelper from "./ApiHelper";


const Parser = {
    previewMessage: async (payload: any) => {
        let result: any = await ApiHelper.post("/parser/previewMessage", payload)
        return result!.data!
    },
    parseMessage: async (payload: any) => {
        let result: any = await ApiHelper.post("/parser/parseCopyPasteMessage", payload)
        console.log("parseMessage type=", payload.type);
        if (result.data)
            return result!.data!
        else
            return result;
    },
    convertMessage: async (payload: any) => {
        /* data mẫu{
            "body":"dc 100 con lo1",
            "date":"2023-08-27",
            "time":"00:00:59",
            "type":1,
            "contactId":1,
            "curMien":"NAM",
            "getCompactData":0,
            "getRawData":0,
            "mienCuPhapId":2,
            "tachXienMay":3,
            "soBoSo":10
        }*/
        let result: any = await ApiHelper.post("/parser/convertMessage", payload)
        return result!.data!
    },
    parseCanChuyenMessage: async (payload: any) => {
        let result: any = await ApiHelper.post("/parser/parseCanChuyenMessage", payload)
        return result!.data!
    },
    deleteMessage: async (messageId: number) => {
        let result: any = await ApiHelper.delete(`/parser/deleteMessage?messageId=${messageId}`)
        return result!.data!
    },
    deleteMessages: async (messageIds: number[]) => {
        const ids = messageIds.join(",")
        let result: any = await ApiHelper.delete(`/parser/deleteMessages?messageIds=${ids}`)
        return result!.data!
    },
    deleteAllData: async (payload: any) => {
        const { ngay } = payload
        let result: any = await ApiHelper.delete(`/parser/deleteAllData?ngay=${ngay}`)
        return result!.data!
    },
    deleteAllDataByDateRange: async (payload: any) => {
        const { ngay,denNgay } = payload
        let result: any = await ApiHelper.delete(`/parser/deleteAllDataByDateRange?ngay=${ngay}&denNgay=${denNgay}`)
        return result!.data!
    }
}


export default Parser;